<template>
    <div class="vx-card p-6">
        <div class="vx-row">
            <div class="vx-col w-full"></div>
            <div class="vx-col w-full">
                <div class="vx-row">
                    <div class="vx-col md:w-1/3 w-full">
                        <label class="vs-input--label">{{ this.$t('timeKeeping.teacherMain') }}</label>
                        <v-select class="" v-model="selectedTeacher" :clearable="false"
                                  :options="teacherOptions" :reduce="option => option.value" @input="changeTeacher" :disabled="userInfo.userRole === 'user'">
                            <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                        </v-select>
                    </div>
                    <div class="vx-col md:w-1/3 w-full">
                        <label class="vs-input--label">{{ this.$t('timeKeeping.className') }}</label>
                        <v-select class="" v-model="selectedClass" :clearable="false" label="label"
                                  :options="classPermissionOptions" :reduce="option => option.value" @input="changeClassroom">
                            <template #option="{ label, organizationBranchName }">
                                <h5 style="margin: 0">{{ label }}</h5>
                                <em>{{ organizationBranchName }}</em>
                            </template>
                            <template #selected-option="{ label, organizationBranchName }">
                                <div class="flex items-center gap-2">
                                    <strong>{{ label }}</strong>
                                    <em>{{ organizationBranchName }}</em>
                                </div>
                            </template>
                            <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                        </v-select>
                    </div>
                    <div class="vx-col md:w-1/3 w-full">
                        <label class="vs-input--label">{{ this.$t('navMenu.student') }}</label>
                        <v-select class="" v-model="selectedStudent" :clearable="false"
                                  :options="studentOptions" :reduce="option => option.value">
                            <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                        </v-select>
                    </div>
                </div>
            </div>
            <div class="vx-col md:w-1/3 w-full mt-2">
                <label class="vs-input--label">{{ $t('invoice.date') }}</label>
                <date-range-picker
                    ref="picker" class="w-full"
                    :locale-data="{format: 'dd/mm/yyyy' }"
                    :opens="'right'"
                    @update="dateRangePicker"
                    v-model="dateRange">
                </date-range-picker>
            </div>
            <div class="vx-col md:w-2/3 w-full">
                <div class="flex justify-between mt-8">
                    <vs-button icon-pack="feather" icon="icon-plus" type="border" @click="$router.push('/user/teacher-interaction-info')">{{ $t('notificationV.addNotification') }}</vs-button>
                    <vs-button icon-pack="feather" icon="icon-search" @click="filter">{{ $t('button.filter') }}</vs-button>
                </div>
            </div>
            <div class="vx-col w-full mt-8">
                <ag-grid-vue style="height: 55vh"
                             ref="agGridTable"
                             :gridOptions="gridOptions"
                             class="ag-theme-material w-100 my-4 ag-grid-table"
                             :columnDefs="columnDefs"
                             :defaultColDef="defaultColDef"
                             :rowData="teacherInteractionData"
                             :animateRows="true"
                             :localeText="  {noRowsToShow: this.$t('menuCustomer.noRowsToShow')} "
                             :onGridReady="onGridReady"
                             :autoSizeStrategy="autoSizeStrategy"
                             tooltipShowDelay="0"
                             tooltipHideDelay="5000"
                             :tooltipMouseTrack="true">
                </ag-grid-vue>

                <div class="vx-row" v-if="teacherInteractionData && teacherInteractionData.length > 0">
                    <div class="vx-col md:w-1/2">
                        <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                            <span class="vx-col mt-2">{{ $t('dashboard.NumberOfElementsPage') }}</span>
                            <vs-dropdown vs-trigger-click class="cursor-pointer">
                                <div
                                    class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                                <span class="mr-2">
                                    {{
                                        teacherInteractionData.length - currentPage * pageSize > 0 ? currentPage *
                                            pageSize
                                            : teacherInteractionData.length
                                    }} /
                                    {{ totalElements }}</span>
                                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                                </div>
                                <vs-dropdown-menu>

                                    <vs-dropdown-item @click="changePageSize(20)">
                                        <span>20</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="changePageSize(30)">
                                        <span>30</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="changePageSize(50)">
                                        <span>50</span>
                                    </vs-dropdown-item>
                                </vs-dropdown-menu>
                            </vs-dropdown>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/2 w-full">
                        <vs-pagination :total="totalPages" v-model="currentPage" @input="loadPage"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import {AgGridVue} from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import {ClientSideRowModelModule} from '@ag-grid-community/client-side-row-model';
import DateRangePicker from '../../../components/vue2-daterange-picker/components/DateRangePicker.vue'
import {ModuleRegistry} from '@ag-grid-community/core';
import CellRendererActions from "./cell-renderer/CellRendererActions";
import moment from "moment";

// Register the required feature modules with the Grid
ModuleRegistry.registerModules([ClientSideRowModelModule]);
export default {
    name: "TeacherInteraction",
    components: {
        AgGridVue,
        vSelect,
        DateRangePicker,
        CellRendererActions
    },

    data() {
        return {
            // AgGrid
            gridApi: null,
            gridOptions: {},
            defaultColDef: {
                flex: 1,
            },
            columnDefs: [
                {
                    headerName: 'STT',
                    field: 'stt',
                    width: 150,
                },
                {
                    headerName: 'Người gửi',
                    field: 'teacherName',
                    width: 150,
                },
                {
                    headerName: 'Người nhận',
                    field: 'studentName',
                    minWidth: 200
                },
                {
                    headerName: 'Nội dung',
                    field: 'content',
                    width: 200,
                },
                {
                    headerName: this.$t('menuOrganization.createdDate'),
                    field: 'createdDateStr',
                    width: 200,
                },
                {
                    headerName: this.$t('menuOrganization.modifiedDate'),
                    field: 'modifiedDateStr',
                    width: 200,
                },
                {
                    headerName: this.$t('button.actions'),
                    field: 'actions',
                    minWidth: 100,
                    cellRenderer: 'CellRendererActions',
                    suppressSizeToFit: true,
                    pinned: 'right'
                },
            ],
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            teacherOptions: [{value: 0, label: 'Tất cả'}],
            selectedTeacher: 0,
            classPermissionOptions: [{value: 0, label: 'Tất cả'}],
            selectedClass: 0,
            studentOptions: [{value: 0, label: 'Tất cả'}],
            selectedStudent: 0,
            dateRange: {
                endDate: null,
                startDate: null
            },
            totalPages: 0,
            currentPage: 1,
            countElementPage: 0,
            totalElements: 0,
            pageNumber: 0,
            pageSize: 30,
            teacherInteractionData: []
        }
    },

    watch: {
        '$store.state.isUpdateTeacherInteraction'(val) {
            if (val) {
                this.filter();
                this.$store.commit('UPDATE_TEACHER_INTERACTION', false);
            }
        }
    },

    async created() {
        if (this.userInfo.userRole === 'organization') {
            await this.getDataTeacher()
        } else {
            this.teacherOptions = [{value: this.userInfo.employeeId, label: this.userInfo.fullName}]
            this.selectedTeacher = this.userInfo.employeeId
            await this.getClassPermission()
        }
        this.getTeacherInteraction()
    },

    methods: {
        getDataTeacher() {
            return new Promise((resolve, reject) => {
                let payload = {
                    departmentType: 1,
                    enabled: true
                }

                this.$vs.loading()
                this.$crm.post('/employee/all', payload).then(res => {
                    if (res.data && res.data.length > 0) {
                        this.teacherOptions = res.data.map(el => {
                            return {
                                value: el.employeeId,
                                label: el.fullName
                            }
                        })
                    } else {
                        this.teacherOptions = []
                    }
                    this.teacherOptions.unshift({value: 0, label: 'Tất cả'})
                    resolve(res)
                    this.$vs.loading.close()
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close()
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                })
            })
        },

        getClassPermission() {
            return new Promise((resolve, reject) => {
                this.$vs.loading()
                this.$crm.post(`/employee/find-by-id/${this.selectedTeacher}`).then(res => {
                    if (res.data.managedClassRooms.length > 0) {
                        let branchList = JSON.parse(localStorage.getItem('branchInfoList'))
                        this.classPermissionOptions = res.data.managedClassRooms.map(el => {
                            let branch = branchList.find(x => x.id === el.organizationBranchId)
                            if (branch) el.organizationBranchName = branch.organizationBranchName
                            return {
                                value: el.id,
                                label: el.className,
                                organizationBranchName: el.organizationBranchName ? el.organizationBranchName : null
                            }
                        })
                    } else {
                        this.classPermissionOptions = []
                    }
                    this.classPermissionOptions.unshift({value: null, label: 'Tất cả'})
                    resolve(res)
                    this.$vs.loading.close()
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close()
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                })
            })
        },

        getStudentData() {
            return new Promise((resolve, reject) => {
                let payload = {
                    classId: this.selectedClass,
                    enabled: true,
                    pageNumber: 1,
                    pageSize: 1000
                }

                this.$vs.loading()
                this.$crm.post('/school-student/find-by-condition', payload).then(res => {
                    if (res.data.content && res.data.content.length > 0) {
                        this.studentOptions = res.data.content.map(el => {
                            return {
                                value: el.id,
                                label: el.fullName
                            }
                        })
                    } else {
                        this.studentOptions = []
                    }
                    this.studentOptions.unshift({value: null, label: 'Tất cả'})
                    resolve(res)
                    this.$vs.loading.close()
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close()
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                })
            })
        },

        getTeacherInteraction() {
            let payload = {
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                studentId: this.selectedStudent ? this.selectedStudent: null,
                teacherId: this.selectedTeacher ? this.selectedTeacher : null,
                startDate: this.dateRange.startDate,
                endDate: this.dateRange.endDate,
            }

            this.$vs.loading()
            this.$crm.post('/teacher-interaction/find-by-condition', payload).then(res => {
                if (res.data.content && res.data.content.length > 0) {
                    this.teacherInteractionData = res.data.content.map(el => {
                        el.modifiedDateStr = el.modifiedDate ? moment(el.modifiedDate).format('DD/MM/YYYY') : null;
                        el.createdDateStr = el.createdDate ? moment(el.createdDate).format('DD/MM/YYYY') : null;
                        el.stt = this.pageSize * this.pageNumber + res.data.content.indexOf(el) + 1
                        el.teacherName = el.teacher.fullName
                        el.studentName = el.student.fullName
                        return el
                    })
                } else {
                    this.teacherInteractionData = []
                }
                this.totalElements = res.data.totalElements
                this.totalPages = res.data.totalPages
                this.$vs.loading.close()
            }).catch(err => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },

        async changeTeacher() {
            this.selectedClass = 0
            this.selectedStudent = 0
            this.classPermissionOptions = [{value: 0, label: 'Tất cả'}]
            this.studentOptions = [{value: 0, label: 'Tất cả'}]
            if (this.selectedTeacher) {
                await this.getClassPermission()
            }
        },

        async changeClassroom() {
            this.selectedStudent = 0
            this.studentOptions = [{value: 0, label: 'Tất cả'}]
            if (this.selectedClass) {
                await this.getStudentData()
            }
        },

        onGridReady(params) {
            this.gridApi = params.api;
        },

        loadPage: function (currentPage) {
            if (this.pageNumber !== (parseInt(currentPage) - 1)) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getTeacherInteraction();
            }
        },

        changePageSize(number) {
            this.pageSize = number;
            this.filter();
        },

        filter() {
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getTeacherInteraction();
        },

        dateRangePicker() {
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59));
        },
    }
}
</script>

<style scoped>

</style>
